var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextBoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6087 1C5.61567 1 4 2.61567 4 4.6087V19.9412C4 21.6305 5.36948 23 7.05882 23H14C17.3137 23 20 20.3137 20 17C20 14.4259 18.3791 12.2304 16.1022 11.3786C17.2702 10.2839 18 8.72715 18 7C18 3.68629 15.3137 1 12 1H7.6087ZM12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3H7.6087C6.72024 3 6 3.72024 6 4.6087V11H12ZM6 13V19.9412C6 20.5259 6.47405 21 7.05882 21H14C16.2091 21 18 19.2091 18 17C18 14.7909 16.2091 13 14 13H6Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBoldIcon);
export default __webpack_public_path__ + "static/media/TextBoldIcon.a51833aa37fbb321d36611573110fe00.svg";
export { ForwardRef as ReactComponent };